import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  FormControlLabel,
  Checkbox,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

const PREFIX = "Pricing";

const classes = {
  root: `${PREFIX}-root`,
  pricingOptions: `${PREFIX}-pricingOptions`,
  maxWidthOptions: `${PREFIX}-maxWidthOptions`,
  marginBottom: `${PREFIX}-marginBottom`,
  mainTitle: `${PREFIX}-mainTitle`,
  loadingContainer: `${PREFIX}-loadingContainer`,
  modifySelect: `${PREFIX}-modifySelect`,
  selectMenuStyle: `${PREFIX}-selectMenuStyle`,
  securedByPaymentCheckBox: `${PREFIX}-securedByPaymentCheckBox`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.root}`]: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.between("xs", "md")]: {
      minWidth: "100%",
      maxWidth: "100%",
    },
  },

  [`& .${classes.pricingOptions}`]: {
    textAlign: "left",
  },

  [`& .${classes.marginBottom}`]: {
    marginBottom: "1rem !important",
  },

  [`& .${classes.mainTitle}`]: {
    textAlign: "left",
    marginTop: "1rem !important",
    marginBottom: "1rem !important",
  },

  [`&.${classes.loadingContainer}`]: {
    textAlign: "center",
  },

  [`& .${classes.modifySelect}`]: {
    width: "100%",
  },

  [`& .${classes.selectMenuStyle}`]: {
    backgroundColor: "#424242",
  },
}));

const Pricing = (props) => {
  const { t } = useTranslation();
  const [securedByPayment, setSecuredByPayment] = useState(false);
  const [packageValue, setPackageValue] = useState("");

  useEffect(() => {
    if (props.exparience?.offeringId && props.exparience?.packageId) {
      setSecuredByPayment(true);
      setPackageValue(
        !props.exparience.packageId ? "" : props.exparience.packageId
      );
    }
  }, [props.exparience]);

  if (!props.offerings) {
    return (
      <Root>
        <div className={classes.loadingContainer}>
          <CircularProgress size={50} color="primary" />
          <Typography variant="body1">{t("loaders.fetching")}</Typography>
        </div>
      </Root>
    );
  } else {
    return (
      <Root>
        <div className={classes.root}>
          <Typography variant="h5" className={classes.mainTitle}>
            {t("myExpariences.pricing")}
          </Typography>
          <div className={classes.pricingOptions}>
            <div className={classes.maxWidthOptions}>
              <div>
                {props.isAdmin && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        color={"primary"}
                        onChange={(e) => {
                          if (!e.target.checked)
                            props.setExparience({
                              ...props.exparience,
                              offeringId: "",
                              packageId: "",
                            });
                          setSecuredByPayment(e.target.checked);
                        }}
                        checked={securedByPayment || false}
                      />
                    }
                    label={
                      <Typography variant="body1">
                        {t("myExpariences.form.securedByPayment")}
                      </Typography>
                    }
                    className={clsx(classes.marginBottom)}
                  />
                )}
                {securedByPayment && (
                  <div>
                    <FormControl className={classes.modifySelect}>
                      <InputLabel id="package-select-outlined-label">
                        {t("myExpariences.selectOffer")}
                      </InputLabel>
                      <Select
                        labelId="package-select-outlined-label"
                        id="package-select-outlined"
                        className={classes.selectStyle}
                        value={
                          !props.exparience.hasOwnProperty("packageId")
                            ? packageValue
                            : props.exparience.packageId
                        }
                        MenuProps={{
                          classes: { paper: classes.selectMenuStyle },
                        }}
                        onChange={(e) => {
                          const tmp = props.offerings.filter(
                            (offer) => offer.id === e.target.value
                          );
                          if (tmp.length > 0)
                            props.setExparience({
                              ...props.exparience,
                              offeringId: tmp[0].offeringId,
                              packageId: e.target.value,
                            });
                          else
                            props.setExparience({
                              ...props.exparience,
                              offeringId: "",
                              packageId: "",
                            });
                        }}
                        label="Package price"
                      >
                        <MenuItem key="none" value="">
                          {t("myExpariences.noOffer")}
                        </MenuItem>
                        {props.offerings.map((offer) => (
                          <MenuItem
                            key={offer.id}
                            value={offer.id}
                          >{`${offer.price}€ - ${offer.duration}`}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Root>
    );
  }
};

export default Pricing;
